import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PortfolioAnalytics from './pages/portfolio-analytics';
import AccountManagement from './pages/account-management';
import MainTradingDashboard from './pages/main-trading-dashboard';
import MarketAnalysisHub from './pages/market-analysis-hub';
import RiskManagementCenter from './pages/risk-management-center';
import LoginScreen from './pages/login-screen';
import RegisterScreen from './pages/register-screen';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Authentication Routes */}
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/register-screen" element={<RegisterScreen />} />
        
        {/* Main Application Routes */}
        <Route path="/" element={<MainTradingDashboard />} />
        <Route path="/portfolio-analytics" element={<PortfolioAnalytics />} />
        <Route path="/account-management" element={<AccountManagement />} />
        <Route path="/main-trading-dashboard" element={<MainTradingDashboard />} />
        <Route path="/market-analysis-hub" element={<MarketAnalysisHub />} />
        <Route path="/risk-management-center" element={<RiskManagementCenter />} />
        
        {/* Navigation Routes */}
        <Route path="/transaction" element={<MainTradingDashboard />} />
        <Route path="/prop" element={<MarketAnalysisHub />} />
        <Route path="/explore" element={<PortfolioAnalytics />} />
        
        {/* Fallback Route */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;